import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const thTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'ชื่อ (ตัวพิมพ์เล็ก ไม่มีอักขระพิเศษ)',
    add: 'เพิ่ม',
    allowedFileTypes: 'ประเภทไฟล์ที่อนุญาต',
    allowedFileTypesDescription:
      'จำกัดประเภทไฟล์ที่อนุญาต (เช่น image/*, application/pdf) เว้นว่างไว้เพื่ออนุญาตทุกประเภท',
    allowMultipleFiles: 'อนุญาตให้หลายไฟล์',
    amountInCents: 'จำนวนเงินเป็นเซนต์',
    basePrice: 'ราคาฐาน',
    bcc: 'สำเนาลับถึง',
    brand: 'ยี่ห้อ',
    cc: 'ซีซี',
    checkboxPlural: 'ช่องช่องทำเครื่องหมาย',
    checkboxSingular: 'ช่องทำเครื่องหมาย',
    checkedByDefault: 'ตรวจสอบโดยค่าเริ่มต้น',
    chooseConfirmationType:
      'เลือกว่าจะแสดงข้อความบนเพจหรือเปลี่ยนเส้นทางไปยังหน้าอื่นหลังจากที่ส่งแบบฟอร์มแล้ว',
    condition: 'สภาพ',
    confirmationMessage: 'ข้อความยืนยัน',
    confirmationType: 'ประเภทการยืนยัน',
    countryPlural: 'เขตข้อมูลประเทศ',
    countrySingular: 'ประเทศ',
    creditCard: 'บัตรเครดิต',
    customURL: 'URL ที่กำหนดเอง',
    datePlural: 'เขตข้อมูลวันที่',
    dateSingular: 'วันที่',
    defaultValue: 'ค่าเริ่มต้น',
    divide: 'แบ่ง',
    documentToLinkTo: 'เอกสารที่จะลิงค์ไป',
    doesNotEqual: 'ไม่เท่ากัน',
    emailFrom: 'อีเมล์จาก',
    emailPlural: 'ฟิลด์อีเมล',
    emailsDescription:
      'ส่งอีเมลที่กำหนดเองเมื่อมีการส่งแบบฟอร์ม ใช้รายการที่คั่นด้วยเครื่องหมายจุลภาคเพื่อส่งอีเมลเดียวกันไปยังผู้รับหลายคน หากต้องการอ้างอิงค่าจากแบบฟอร์มนี้ ให้ล้อมชื่อของช่องนั้นด้วยวงเล็บปีกกาคู่ เช่น {{firstName}} คุณสามารถใช้ไวด์การ์ด {{*}} เพื่อส่งออกข้อมูลทั้งหมด และ {{*:table}} เพื่อจัดรูปแบบเป็นตาราง HTML ในอีเมล',
    emailSingular: 'อีเมล',
    emailTo: 'ส่งอีเมลถึง',
    equals: 'เท่ากับ',
    field: 'สนาม',
    fields: 'เขตข้อมูล',
    fieldWidth: 'ความกว้างของฟิลด์ (เปอร์เซ็นต์)',
    hasAnyValue: 'มีค่าใดๆ',
    internalLink: 'ลิงค์ภายใน',
    label: 'ป้ายกำกับ',
    maxFileSize: 'ขนาดไฟล์สูงสุด (ไบต์)',
    maxFileSizeDescription: 'ขนาดไฟล์สูงสุดเป็นไบต์ เว้นว่างไว้โดยไม่มีขีดจำกัด',
    message: 'ข้อความ',
    messageDescription: 'ป้อนข้อความที่ควรส่งในอีเมลนี้',
    messagePlural: 'บล็อกข้อความ',
    messageSingular: 'ข้อความ',
    mimeType: 'ประเภทไมม์',
    mimeTypePlural: 'ประเภทไมม์',
    mimeTypeSingular: 'ประเภทไมม์',
    multiply: 'ทวีคูณ',
    numberPlural: 'ฟิลด์ตัวเลข',
    numberSingular: 'หมายเลข',
    optionPlural: 'ตัวเลือก',
    optionSingular: 'ตัวเลือก',
    paymentFieldPlural: 'ฟิลด์การชำระเงิน',
    paymentFieldSingular: 'การชำระเงิน',
    paymentProcessor: 'หน่วยประมวลผลการชำระเงิน',
    paymentStatus: 'สถานะ',
    placeholder: 'ตัวยึดตำแหน่ง',
    priceConditions: 'เงื่อนไขราคา',
    priceConditionsPlural: 'เงื่อนไขราคา',
    priceConditionsSingular: 'สภาพราคา',
    radioOptions: 'ตัวเลือกคุณลักษณะวิทยุ',
    radioPlural: 'สนามวิทยุ',
    radioSingular: 'วิทยุ',
    redirect: 'เปลี่ยนเส้นทาง',
    replyTo: 'ตอบกลับ',
    required: 'จำเป็น',
    selectOptions: 'เลือกตัวเลือก',
    selectPlural: 'เลือกเขตข้อมูล',
    selectSingular: 'เลือก',
    statePlural: 'เขตข้อมูลของรัฐ',
    stateSingular: 'รัฐ',
    staticValue: 'ค่าคงที่',
    subject: 'เรื่อง',
    submitButton: 'ส่งป้ายกำกับปุ่ม',
    subtract: 'ลบ',
    textareaPlural: 'เขตข้อมูลข้อความ',
    textareaSingular: 'พื้นที่ข้อความ',
    textPlural: 'ช่องข้อความ',
    textSingular: 'ข้อความ',
    title: 'ชื่อเรื่อง',
    token: 'โทเค็น',
    uploadCollection: 'อัปโหลดคอลเลกชัน',
    uploadCollectionDescription: 'เลือกคอลเลกชันการอัปโหลดที่จะจัดเก็บไฟล์',
    uploadFieldPlural: 'อัพโหลดฟิลด์',
    uploadFieldSingular: 'อัปโหลด',
    urlToRedirectTo: 'URL ที่จะเปลี่ยนเส้นทางไป',
    value: 'ความคุ้มค่า',
    valueOfField: 'ค่าของฟิลด์',
    valueType: 'ประเภทค่า',
  },
}

export const th: PluginLanguage = {
  dateFNSKey: 'th',
  translations: thTranslations,
}
